import { DefaultTheme } from "styled-components";

const mainTheme: DefaultTheme = {
  colors: {
    mainColors: {
      dark: "#2d2d2d",
      gray: "#EEEEEE",
    },
    error: {
      base: "#fbbaba",
    },
    success: {
      base: "#a8f0e3",
    },
  },

  fontWeights: {
    bold: 700,
    regular: 400,
  },
};

export default mainTheme;
